import { FC, ReactNode } from 'react';
import type { SopMes } from '@/types/dashboards';
import { periodoCurto } from '@/utils/painelFormat';
import RotuloMes from './RotuloMes';

interface Props {
  meses: SopMes[];
  mes: string;
  onMes: (mes: string) => void;
  /** Complemento do chip (ex.: "· parcial"). */
  extra?: (mes: SopMes) => ReactNode;
}

/** Chips de um mês de produção (16 a 15), um só selecionado. */
const SeletorMesProducao: FC<Props> = ({ meses, mes, onMes, extra }) => (
  <div role="group" aria-label="Mês de produção" className="flex flex-wrap items-center gap-1.5">
    <span className="mr-1 text-xs uppercase tracking-wide text-content-muted">Mês</span>
    {meses.map((m) => {
      const ativo = m.key === mes;
      return (
        <button
          key={m.key}
          type="button"
          aria-pressed={ativo}
          title={`${m.label}: ${m.range}`}
          onClick={() => onMes(m.key)}
          className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-3 py-1 text-xs transition-colors ${
            ativo
              ? 'border-accent bg-accent font-semibold text-accent-contrast'
              : 'border-theme-border text-content-secondary hover:text-content-primary'
          }`}
        >
          <RotuloMes label={m.label} periodo={periodoCurto(m)} />
          {extra?.(m)}
        </button>
      );
    })}
  </div>
);

export default SeletorMesProducao;
